import { Colors } from '../../../../../../../colors';

export enum SidebarMenuItemVariant {
  Selected = 'Selected',
  Unselected = 'Unselected',
}
export const SidebarMenuItemBgColors = {
  [SidebarMenuItemVariant.Selected]: Colors.Beige,
  [SidebarMenuItemVariant.Unselected]: Colors.Transparent,
};

export const SidebarMenuItemTextColors = {
  [SidebarMenuItemVariant.Selected]: Colors.DarkGrey,
  [SidebarMenuItemVariant.Unselected]: Colors.PrimaryDark,
};
